interface RankingProps {
    completedActivities: number;
    targetActivities: number;
    labels: { index: number; label: string }[];
    color?: string;
}

function lightenColor(hex: string): string {
    const num = parseInt(hex.replace("#", ""), 16);
    const r = (num >> 16) & 0xff;
    const g = (num >> 8) & 0xff;
    const b = num & 0xff;
    const normalizedAmount = 0.75;
    const newR = Math.round(r + (255 - r) * normalizedAmount);
    const newG = Math.round(g + (255 - g) * normalizedAmount);
    const newB = Math.round(b + (255 - b) * normalizedAmount);
    return `#${((newR << 16) | (newG << 8) | newB)
        .toString(16)
        .padStart(6, "0")}`;
}

export default function Ranking({
    completedActivities,
    targetActivities,
    labels,
    color = "#0aa09d",
}: RankingProps) {
    const lightenedColor = lightenColor(color);

    const width = `${100 / targetActivities}%`;

    const allLabels = Array.from({ length: targetActivities }).map(
        (_, index) => labels.find((label) => label.index === index)?.label || ""
    );

    return (
        <div className="user-ranking">
            <div className="user-ranking-labels">
                {allLabels.map((label, index) => (
                    <div
                        key={`${index}`}
                        className={`flex flex-col gap-2 user-ranking-label`}
                        style={{ width, minWidth: width }}
                    >
                        {label}
                    </div>
                ))}
            </div>
            <div
                className="user-ranking-bars"
                style={{
                    backgroundColor: lightenedColor,
                    gap: targetActivities > 10 ? "1px" : "4px",
                }}
            >
                {allLabels.map((label, index) => (
                    <div
                        key={`${index}-${label}`}
                        className={`flex flex-col gap-2 user-ranking-bar ${
                            index < (completedActivities || 0)
                                ? "animate-bar"
                                : ""
                        }`}
                        style={
                            {
                                backgroundColor: color,
                                opacity: 0.1,
                                animationDelay: `${
                                    (index * 4) / allLabels.length
                                }s`,
                                "--target-opacity":
                                    index < (completedActivities || 0)
                                        ? (index + 2) /
                                          Math.min(
                                              completedActivities + 1,
                                              allLabels.length + 1
                                          )
                                        : 0.1,
                            } as React.CSSProperties
                        }
                    />
                ))}
            </div>
        </div>
    );
}
